import { options_premium_TravelSaving_Service } from './ServiceOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
import { store, PremiumExperienceType } from 'owa-premium-travel/lib/store/premiumTravelStore';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ServiceOption: LazyOption = createLazyOption(
    {
        key: 'service_',
        titleStringKey: options_premium_TravelSaving_Service,
        searchTermsStringKey: options_premium_TravelSaving_Service,
        hideTitleInFullOptions: false,
        isHidden: () =>
            !(
                isFeatureEnabled('auth-TravelDashboardEnabled') &&
                store.premiumExperienceType == PremiumExperienceType.PremiumTravel
            ),
        icon: require('owa-premium-manageassistant-option/lib/resources/icons/logo-service-monochrome.svg'),
    },
    lazyFullModule,
    m => m.default
);
export default ServiceOption;
